import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "The3DMprToggle"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.25 1.5H1.5V8.25H3V3H8.25V1.5ZM1.5 15.75V22.5H8.25V21H3V15.75H1.5ZM22.5 8.25V1.5H15.75V3H21V8.25H22.5ZM15.75 22.5H22.5V15.75H21V21H15.75V22.5ZM19.1175 7.59748L12.3675 3.84748C12.1354 3.71351 11.8495 3.71351 11.6175 3.84748L4.86749 7.59748C4.6374 7.73389 4.49737 7.98251 4.49999 8.24998V15.75C4.50045 16.0206 4.64662 16.2699 4.88249 16.4025L11.6325 20.1525C11.8645 20.2865 12.1504 20.2865 12.3825 20.1525L19.1325 16.4025C19.3626 16.2661 19.5026 16.0175 19.5 15.75V8.24998C19.4995 7.97941 19.3534 7.73006 19.1175 7.59748ZM12.0001 5.35503L17.2051 8.25003L12.0001 11.145L6.79511 8.25003L12.0001 5.35503ZM6 9.52501L11.25 12.4425V18.225L6 15.3075V9.52501ZM12.75 18.225V12.4425L18 9.52501V15.3075L12.75 18.225Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/The3DMprToggle.vue"]]);
